// src/features/stock/pages/StockAreaPage.jsx
import { Stack } from "@mui/material";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../../../app/providers/AuthProvider";
import StockSectionsGrid from "../components/StockSectionsGrid";
import {
  canAccessStockSubsection,
  getStockSectionByPath,
} from "../constants/stockAreas";

export default function StockAreaPage() {
  const navigate = useNavigate();
  const { sectionPath } = useParams();
  const { user } = useAuth();

  const section = getStockSectionByPath(sectionPath);

  if (!section) return <Navigate to="/stock" replace />;

  const submenuItems = section.children
    .filter((item) => canAccessStockSubsection(item, user))
    .map((item) => ({
      ...item,
      to: `/stock/${section.path}/${item.path}`,
    }));

  const handleAreaClick = (area) => {
    if (area?.to) navigate(area.to);
  };

  return (
    <Stack
      spacing={2}
      sx={{
        pt: 2,
        pr: 3,
        pl: 0,
        width: "100%",
        minWidth: 0,
        overflowX: "hidden",
      }}
    >
      <Stack sx={{ flex: 1, width: "100%", minWidth: 0 }}>
        <StockSectionsGrid
          areas={submenuItems}
          onAreaClick={handleAreaClick}
          title={`Subareas de ${section.label}`}
        />
      </Stack>
    </Stack>
  );
}
